import React, { useCallback } from 'react';

import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import cls from './ManagerCard.module.css';
import { useManagerCard } from './useManagerCard';
import { dashboardActions } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';

interface ManagerCardProps {
    src?: string;
    name?: string;
    classes?: string;
    onClick?: () => void;
    id: number | null;
    needComa: boolean;
}

export const ManagerCard = ({ classes, src, name, onClick, id, needComa }: ManagerCardProps) => {
    const {} = useManagerCard();
    const dispatch = useDispatch();

    const onClickManagerCard = useCallback(() => {
        dispatch(dashboardActions.changeCurrentManagerId(id));
        onClick();
    }, []);
    return (
        <div className={classNames(cls.ManagerCard, [classes])} onClick={onClickManagerCard}>
            {/* {!!src ? <img src={src} alt={name} /> : <Icon iconName={'profile'} />} */}
            <span title={name ?? ''} className={cls.managerName}>
                {name}
                {needComa && ','}
            </span>
        </div>
    );
};
